
const env = window._env_ || {};

const config = {
  apiDomain: env.API_DOMAIN,
  clientsUrl: env.API_DOMAIN + '/load-clients',
  dashboardUrl: env.API_DOMAIN + '/dashboard',
  infoTabsUrl: env.API_DOMAIN + '/info/tabs',
  infoTabSectionsUrl: env.API_DOMAIN + '/info/tab',
  recommendationsUrl: env.API_DOMAIN + '/recommendations',
  recommendationDismissUrl: env.API_DOMAIN + '/recommendations/update',
  recommendationFeedbackUrl: env.API_DOMAIN + '/recommendations/feedback',
  feedbackUrl: env.API_DOMAIN + '/feedback/send',
  reportUrl: env.API_DOMAIN + '/issues/export/report',
  acceptSplash: env.API_DOMAIN + '/splash/accept',
  cancelSplash: env.API_DOMAIN + '/splash/cancel',
  contextHelpUrl: env.API_DOMAIN + '/context-help-data',
  extensionsUrl: env.API_DOMAIN + '/extensions',
  exceptionsUrl: env.API_DOMAIN + '/exceptions',
  alertsUrl: env.API_DOMAIN + '/alerts',
  patchesUrl: env.API_DOMAIN + '/patches',
  recommendedPatchesUrl: env.API_DOMAIN + '/patches/recommended',
  uctReportUrl: env.API_DOMAIN + '/uct/report/download',
  uctScanRunUrl: env.API_DOMAIN + '/uct/scan',
  securityScanAddUrl: env.API_DOMAIN + '/security-scan/add',
  securityScanReportUrl: env.API_DOMAIN + '/security-scan/report',
  productSearchUrl: env.API_DOMAIN + '/livesearch/submit',
  productDataUrl: env.API_DOMAIN + '/livesearch/get-data',
  preLaunchChecksUrl: env.API_DOMAIN + '/prelaunch-checks',
  preLaunchCheckSaveUrl: env.API_DOMAIN + '/prelaunch-checks/save',
  preLaunchCheckEmailSummary: env.API_DOMAIN + '/prelaunch-checks/email',
  preLaunchCheckDocGen: env.API_DOMAIN + '/prelaunch-checks/docgen',
  feedbackSettingsUrl: env.API_DOMAIN + '/user/feedback-settings',
};

export const getConfig = key => {
  if (config.hasOwnProperty(key)) {
    return config[key];
  } else if (env.hasOwnProperty(key)) {
    return env[key];
  }
  throw new Error(key + ' is not defined');
};
